import React, { useEffect, useState } from "react";
import { Col,Row } from "react-bootstrap";
import HelpButton from "../HelpContent/HelpButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-regular-svg-icons";
import Subheading from "../Common/Subheading";
import OrganisationIcon from "../../assets/icons/global_settings.svg2";
import BillingInformation from "./BillingInformation";
import MyOrganisation from "./MyOrganisation";
import {
  useGetOrganisationSettingsDataQuery,
  useUpdateOrganisationSettingsDataMutation,
} from "../store/slices/settingsSlice";
import { toast } from "react-toastify";
import WeatherSettings from "./WeatherSettings";
import { isUserPermitted } from "../helpers/pageProps";

const { countries, defaultCountry, defaultTZ } = JSON.parse(
  document.querySelector("#app").dataset.page
).props;

function OrganisationSettings() {
  const canEdit = isUserPermitted("edit_organisation_setting");
  const [organisationDetails, setOrganisationDetails] = useState();
  const [errors, setErrors] = useState({});

  const { data } = useGetOrganisationSettingsDataQuery();
  useEffect(() => {
    setOrganisationDetails(data);
  }, [data]);

  const [save] = useUpdateOrganisationSettingsDataMutation(organisationDetails);
  const handleSave = async () => {
    setErrors({});
    const response = await save(organisationDetails);
    if (response.error) {
      toast.error(
        response.error?.data?.message ||
          response.error?.data?.error ||
          "There is an error"
      );
      setErrors(response.error?.data?.errors || {});
      return;
    }
    if (response.data.status === "success") {
      toast.success("Settings saved successfully");
    }
  };

  const handleOrganisationDetailsChange = (e) => {
    setOrganisationDetails((prev) => ({
      ...prev,
      [e.target.name.split(".")[0]]: {
        ...prev[e.target.name.split(".")[0]],
        [e.target.name.split(".")[1]]: e.target.value,
      },
    }));
  };

  return (
    organisationDetails && (
      <div className="mb-5">
        <Subheading
          Icon={OrganisationIcon}
          heading="Organisation Settings"
          subheading="Your default Organisations system settings."
        />
        <fieldset disabled={!canEdit} className="border-0 p-0 m-0">
          <div className="my-3">
          <Row xs={1} xl={2}>
            <Col>
              <MyOrganisation
                handleOrganisationDetailsChange={
                  handleOrganisationDetailsChange
                }
                organisationDetails={organisationDetails}
                countries={countries}
                errors={errors}
              />
            </Col>
            <Col>
              <BillingInformation
                organisationDetails={organisationDetails}
                handleOrganisationDetailsChange={
                  handleOrganisationDetailsChange
                }
                errors={errors}
              />
            </Col>
          </Row>
        </div>
        <div className="d-flex justify-content-end">
          <button
            onClick={handleSave}
            type="button"
            className="btn btn-colored-reverse rounded-pill fw-bold "
            disabled={!canEdit}
          >
            <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
            SAVE SETTINGS{" "}
          </button>
        </div>
        <hr className="my-5 text-secondary" />
        <div className="my-3">
          <Row xs={1} xl={2}>
            <Col>
              <WeatherSettings
                handleOrganisationDetailsChange={
                  handleOrganisationDetailsChange
                }
                organisationDetails={organisationDetails}
                countries={countries}
                errors={errors}
                setOrganisationDetails={setOrganisationDetails}
              />
            </Col>
          </Row>
          {/* <Row xs={1} xl={2}>
          <Col className="g-3">
            <div className="bg-purple-gradient-darker-reverse rounded-4 p-5 ">
              <MyCollapse
                heading={
                  <>
                    <h5 className=" d-flex align-items-center">
                      <MyIcon Icon={BillingDetailsIcon} className="me-2" />
                      <span className="ms-2">
                        <span className="fw-bold me-2">
                          {" "}
                          Organisation Settings :
                        </span>
                        <HelpButton />
                        <div className="small text-secondary">
                          Control your organisation settings{" "}
                        </div>
                      </span>
                    </h5>
                    <hr className="my-3 text-secondary" />
                  </>
                }
              >
                <FloatingLabel label=" Boom Dev:" className="mb-2">
                  <Form.Control
                    name="boomDev"
                    placeholder="Boom Dev"
                    onChange={handleOrganisationSettingsChange}
                    value={organisationSettings.boomDev}
                  />
                </FloatingLabel>

                <FloatingLabel label="Logic:" className="mb-2">
                  <Form.Control
                    name="logic"
                    placeholder="Logic"
                    onChange={handleOrganisationSettingsChange}
                    value={organisationSettings.logic}
                  />
                </FloatingLabel>
                <FloatingLabel label="Role:" className="mb-2">
                  <Form.Control
                    onChange={handleOrganisationSettingsChange}
                    name="role"
                    placeholder="Role"
                    value={organisationSettings.role}
                  />
                </FloatingLabel>
                <FloatingLabel label="Customer:" className="mb-2">
                  <Form.Control
                    onChange={handleOrganisationSettingsChange}
                    placeholder="Customer"
                    name="customer"
                    value={organisationSettings.customer}
                  />
                </FloatingLabel>

                <FloatingLabel label="Account:" className="mb-2">
                  <Form.Control
                    name="account"
                    placeholder="account"
                    onChange={handleOrganisationSettingsChange}
                    value={organisationSettings.account}
                  />
                </FloatingLabel>
                <FloatingLabel label="Email:" className="mb-2">
                  <Form.Control
                    type="email"
                    name="organisationSetEmail"
                    placeholder="Email"
                    onChange={handleOrganisationSettingsChange}
                    value={organisationSettings.organisationSetEmail}
                  />
                </FloatingLabel>
              </MyCollapse>
            </div>
          </Col>
        </Row> */}
        </div>
      </fieldset>
      </div>
    )
  );
}

export default OrganisationSettings;
